import { EvidenciaOportunidad } from "src/app/shared/model/gestion-proyectos/evidenciasOportunidad";
import { OperativoService } from "../opeartivo.service";
import { PdfService } from "../Directivas/PdfService";
import { Msg } from "src/app/utilerias/mensajes/Msg";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { EstatusProyecto } from "src/app/shared/model/proceso/estadoProyecto";
import { ModalAgregarComentarioComponent } from "./modal-agregar-comentario/modal-agregar-comentario.component";
import { comentariosOportunidad } from "../modelos/comentariosOportunidad.model";
import { Proyecto } from "src/app/shared/model/gestion-proyectos/proyecto";
import Swal from "sweetalert2";
import { ArchivosUtileriasService } from "src/app/utilerias/service/archivo-utilerias.service";

export abstract class SeguimientoOportunidadBaseComponent {
  public estatusEnum = EstatusProyecto;
  public listaComentarios: comentariosOportunidad[] = [];
  public regexFormatoEstimacion = new RegExp(
    `^(${"FMD-002-"}|${"FDS-039-"}|${"FMD-015-"}|${"FDS-008UCP-"}|${"FDS-009-"}|${"FMD-018"}).*`,
    "i"
  );
  public listaEstimacionAgregar = [];
  public listaEstimacionAgregarSelect = [];
  constructor(
    protected service: OperativoService,
    protected pdfService: PdfService,
    protected msg: Msg,
    protected dialog: MatDialog,
    protected sanitizer: DomSanitizer,
    private archivoUtilService: ArchivosUtileriasService
  ) {}
  public getConfirmacionRegresar() {
    return Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
      title: "¡Atención!",
      html:
        "<p>Ten en cuenta que si vuelves al inicio sin guardar, perderás los cambios realizados.</p>" +
        "<p> ¿Deseas salir? </p>",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí",
      cancelButtonText: "No",
      reverseButtons: true,
    });
  }
  public getConfirmacionSinEstimacion() {
    return Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
      title: "¡Atención!",
      html:
        "<p>No se ha cargado ninguna estimación o propuesta técnica.</p>" +
        "<p> ¿Deseas continuar? </p>",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí",
      cancelButtonText: "No",
      reverseButtons: true,
    });
  }
  public getComentarioCambioEstado() {
    return Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
      },
      text: "Agrega un comentario para continuar",
      buttonsStyling: false,
      icon: "success",
      input: "text",
      showCloseButton: true,
      allowEnterKey: false,
      allowOutsideClick: false,
      confirmButtonText: "Guardar",
      inputValidator: (nombre) => {
        if (!nombre) {
          return "Agregar un comentario para poder continuar";
        } else {
          return undefined;
        }
      },
    });
  }
  public getComentarioRechazo() {
    return Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
      },
      icon: "warning",
      text: " Agrega un comentario para explicar el motivo del rechazo",
      input: "text",
      buttonsStyling: false,
      showCloseButton: true,
      confirmButtonText: "Enviar",

      inputValidator: (nombre) => {
        if (!nombre) {
          return "Agregar un comentario para poder continuar";
        } else {
          return undefined;
        }
      },
    });
  }
  public guardarComentarioService(
    oportunidad: Proyecto,
    descripcionComentario
  ) {
    let comentariodata: comentariosOportunidad = new comentariosOportunidad();
    comentariodata.contenido = descripcionComentario;
    comentariodata.idGit = oportunidad.idGit;
    comentariodata.estado = oportunidad.estado;
    comentariodata.archivosComentarios = [];
    this.service
      .guardarComentarioOportunidad(comentariodata)
      .subscribe((res) => {});
  }
  public agregarComentario(tituloComentario, oportunidadObj: Proyecto) {
    let dialogRef = this.dialog.open(ModalAgregarComentarioComponent, {
      height: "720px",
      width: "1200px",
      panelClass: "custom-modalbox",
      data: {
        idGit: oportunidadObj.idGit,
        grupo: oportunidadObj.grupo,
        nombreCliente: oportunidadObj.nombreCliente,
        tituloComentario: tituloComentario,
        estado: oportunidadObj.estado,
      },
    });
    dialogRef.afterClosed().subscribe((resultado) => {
      if (resultado && resultado.pCodRetorno === "00000") {
        this.consultarComentarios(oportunidadObj.idGit);
      }
    });
  }
  public consultarComentarios(idGit: number) {
    this.service
      .consultarComentarioOportunidad(idGit)
      .subscribe((respuesta) => {
        this.listaComentarios = respuesta;
        this.listaComentarios.forEach((element) => {
          element.estatus = EstatusProyecto[element.estado.toString()];
        });
      });
  }
  public descargaEvidenciaComentario(descargarchivo: EvidenciaOportunidad) {
    const data = {
      idGitProyecto: 0,
      nombreArchivo: null,
      rutaArchivo: descargarchivo.ruta_archivo,
    };

    this.service.muestraEvidencia(data).subscribe((res) => {
      if (res) {
        this.archivoUtilService.descargarArchivo(res.content, descargarchivo.name, descargarchivo.type);
      } else
        this.msg.showErrorNotification(
          "top",
          "No fue posible descargar el archivo"
        );
    });
  }
  public descargaEvidencia(idGit: number, nombre: string, tipo: string) {
    const data = {
      idGitProyecto: idGit,
      nombreArchivo: nombre,
    };
    this.service.muestraEvidencia(data).subscribe((res) => {
      if (res) {
        this.archivoUtilService.descargarArchivo(res.content, res.name, tipo);
      } else
        this.msg.showErrorNotification(
          "top",
          "No fue posible descargar el archivo"
        );
    });
  }
  public consultarArchivoComentario(archivo: EvidenciaOportunidad) {
    const reqConsulta = {
      idGitProyecto: 0,
      nombreArchivo: null,
      rutaArchivo: archivo.ruta_archivo,
    };
    this.consultarArchivoService(reqConsulta, archivo);
  }

  public consultarArchivoEstimacion(
    idGit: number,
    nombre: string,
    tipo: string
  ) {
    if (
      idGit != null &&
      nombre != null &&
      idGit != undefined &&
      nombre != undefined
    ) {
      const reqConsulta = {
        idGitProyecto: idGit,
        nombreArchivo: nombre,
      };
      const archivo = new EvidenciaOportunidad();
      archivo.type = tipo;
      archivo.name = nombre;

      this.consultarArchivoService(reqConsulta, archivo);
    }
  }

  private consultarArchivoService(reqConsulta, archivo: EvidenciaOportunidad) {
    this.service
      .muestraEvidencia(reqConsulta)
      .subscribe((respuestaComentario) => {
        if (respuestaComentario) {
          let contenidoArchivo = respuestaComentario.fileArchivo
            ? respuestaComentario.fileArchivo
            : respuestaComentario.content;
          this.archivoUtilService. mostrarVistaPreviaTipoArchivo(archivo, contenidoArchivo);
          
        } else
          this.msg.showErrorNotification(
            "top",
            "No fue posible obtener el archivo"
          );
      });
  }

  public obtenerImagenTipoArchivo(tipo: string): string {
   return this.archivoUtilService.obtenerImagenTipoArchivo(tipo);
  }
  public cargarEstimacion() {
    this.listaEstimacionAgregar=this.archivoUtilService.agregarCargaArchivo("nameFileEstimacion", this.listaEstimacionAgregar,this.regexFormatoEstimacion);
  }

  public removerEstimacion() {
    this.listaEstimacionAgregar=this.archivoUtilService.removerCargaArchivo("nameFileEstimacion", this.listaEstimacionAgregar, this.listaEstimacionAgregarSelect);
    this.listaEstimacionAgregarSelect = [];
  }

  public onNgModelChangeEstimacion($event) {
    this.listaEstimacionAgregarSelect = $event;
  }

  public obtenerRequestFileForm(idGit, listaArchivosAgregar): FormData {
    const reqForm = new FormData();
    reqForm.append("idProyecto", idGit.toString());
    for (const archivo of this.listaEstimacionAgregar) {
      reqForm.append("file", archivo, archivo.name);
    }
    return reqForm;
  }

  public obtenerListaEstimacionesAgregar (listaAgregar:any[]):any []{
    let listaEvidenciaEstimacion = [];
    listaAgregar.forEach((element) => {
      listaEvidenciaEstimacion.push({
        name: element.name,
        type: element.type,
      });
    });
    return listaEvidenciaEstimacion;
}
}